import { connect } from 'react-redux'
import ForgotPasswordPage from '../components/ForgotPasswordPage'
import { actions } from '../modules/restartParticipant'

const mapStateToProps = state => {
  const { restartParticipant } = state
  const { restartPassword, passwordError } = restartParticipant
  return {
    password: restartPassword,
    passwordError
  }
}

const mapDispatchToProps = { ...actions }

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForgotPasswordPage)
